<template>
    <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :width="180"
            max-height="80vh"
            left
            offset-x
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                    color="black"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    x-large
                    data-test-id="burger"
            >
                <v-icon>mdi-menu</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-list>
                <v-list-item>
                    <v-list-item-avatar color="grey">
                        <v-icon dark large>
                            mdi-account-circle
                        </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{ userData.name }} {{ userData.surname }}</v-list-item-title>
                        <v-list-item-subtitle>Смена {{ shiftData.id }} открыта {{ shiftData.opened_at }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        color="red"
                                        v-on="on"
                                        icon
                                        @click="logOut"
                                        :disabled="cDisLogOut"
                                >
                                    <v-icon>mdi-logout-variant</v-icon>
                                </v-btn>
                            </template>
                            <span> выйти </span>
                        </v-tooltip>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item>
                    <v-list-item-avatar>
                        <template v-if="kkmLoading">
                            <v-progress-circular
                                    indeterminate
                                    color="green"
                            ></v-progress-circular>
                        </template>
                        <template v-else-if="kkmData.status == 'ready'">
                            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
                        </template>
                        <template v-else>
                            <v-icon>mdi-close-circle-outline</v-icon>
                        </template>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>
                            <template v-if="kkmLoading">
                                Подключение ККМ
                            </template>
                            <template v-if="!kkmLoading && kkmData.result">
                                <v-list-item-title v-if="kkmData.status == 'ready'" style="color: green;">Готова к
                                    работе
                                </v-list-item-title>
                                <v-list-item-title v-else style="color: red;">{{ kkmData.status }}</v-list-item-title>
                                <v-list-item-title class="kkmErrors">{{ kkmData.errorDescription }}</v-list-item-title>
                            </template>
                            <template v-if="kkmData.status == 'inProgress' || kkmData.status == 'wait'">
                                <v-list-item-title class="loading">Касса не ответила(</v-list-item-title>
                            </template>
                            <template v-if="kkmData.errorCode > 0">
                                <v-list-item-title class="kkmErrors">{{ kkmData.errorDescription }}</v-list-item-title>
                            </template>
                        </v-list-item-title>
                        <v-list-item-subtitle v-if="!kkmLoading && kkmData.result">
                            <v-list-item-title v-if="kkmShiftStatus == 'closed'" style="border: 1px; color: red;">Смена
                                закрыта
                            </v-list-item-title>
                            <v-list-item-title v-if="kkmShiftStatus == 'opened'" style="color: green;">Смена открыта
                            </v-list-item-title>
                        </v-list-item-subtitle>
                        <v-list-item-action v-if="kkmData.errorCode > 0">
                            <v-btn
                                    icon
                                    color="green"
                                    @click="reloadKKMStatus"
                            >
                                <v-icon>
                                    mdi-sync
                                </v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider class="my-0"></v-divider>
            <v-list>
                <v-list-item-group
                        v-model="selectedItem"
                        color="primary"
                >
                    <template v-for="(item, index) in menuList">
                        <v-list-item
                                v-if="checkLoginPage(item)"
                                link
                                :disabled="item.disabled"
                                :key="'list' + index"
                                @click="linkAction(item.action)"
                                :data-test-id="`link-${item.action}`"
                        >
                            <v-list-item-title>
                                {{ item.name }}
                            </v-list-item-title>
                        </v-list-item>
                    </template>
                </v-list-item-group>
            </v-list>
            <v-treeview
                    open-on-click
                    :items="informationMenu"
                    :item-children="'child'"
                    :item-text="'title'"
                    :hoverable="true"
                    return-object
                    ref="myTreeview"
            >
                <template #label="{item}">
                    <div type="button" class="burger-tree-button" @click="clickOnBurgerItem(item)">
                        {{item.title}}
                    </div>
                </template>
            </v-treeview>
        </v-card>
    </v-menu>
</template>

<script>
    import {mapGetters} from 'vuex'
    import BurgerContentModal from './BurgerContentModal';

    export default {
        data() {
            return{
                menuList: [
                    {
                        name: 'Главный экран',
                        routeName: '/',
                        action: 'toHome',
                        active: false,
                        disabled: false,
                        loginPage: false
                    },
                    {
                        name: 'Новый заказ',
                        routeName: '/order/new',
                        action: 'toNewOrder',
                        active: false,
                        disabled: false,
                        loginPage: false
                    },
                    {
                        name: 'Посмотреть детали смены',
                        routeName: '/shift',
                        action: 'toShiftPage',
                        active: false,
                        disabled: false,
                        loginPage: false
                    },
                    {
                        name: 'Инкассация',
                        routeName: '/',
                        action: 'toCollector',
                        active: false,
                        disabled: false,
                        loginPage: true
                    },
                    {
                        name: 'Услуги',
                        routeName: '/order/chooseservices',
                        action: 'toServices',
                        active: false,
                        disabled: true,
                        loginPage: false
                    },
                ],
                disLogOut: false,
                fav: true,
                menu: false,
                message: false,
                hints: true,
                color: 'green',
                width: '',
                selectedItem: null,
            }
        },
        async mounted() {
            let routeIndex = this.menuList.findIndex(i => i.routeName === this.$router.history.current.path)
            this.selectedItem = routeIndex > -1 ? routeIndex : null
            this.$store.dispatch('fetchKKMStatus')
        },
        computed: {
            ...mapGetters([
                'kkmData',
                'kkmLoading',
                'kkmShiftStatus',
                'displayNone',
                'userData',
            ]),
            ...mapGetters('shift', [
                'shiftData',
                'shiftLoading',
            ]),
            ...mapGetters('information', [
                'information',
            ]),
            informationMenu() {
                const obj = {
                    title: 'Информация',
                }
                if (this.information.length) {
                    obj.child = this.information
                }
                return [obj]
                // {
                //     title: 'audio',
                //         content: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3',
                //     is_href: true
                // },
                // {
                //     title: 'youtube',
                //         content: 'https://www.youtube.com/embed/KYzFqt2Unv0',
                //     is_href: true
                // }
            },
            cDisLogOut() {
                if (this.$route.name === 'login') return true
                return this.disLogOut
            },
        },
        methods: {
            matchYoutubeUrl(url) {
                var p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
                return !!url.match(p);
            },
            getTypeLink(url) {
                const slpitUrl = url.split('.')
               return slpitUrl[slpitUrl.length - 1]
            },
            linkIsAudio(link) {
                const types =['mp3', 'ogg', 'wav']
                const type = this.getTypeLink(link);
                return types.includes(type);
            },
            openModal(type, content) {
                this.$modal.show(BurgerContentModal, {
                    type, content
                }, {
                    height: 700,
                    width: 900
                }, );
            },
            clickOnBurgerItem(item) {
              console.log('pppp', item)
                const content = item.content
                const contentIsHref = item.is_href

                if (!content || (item.child && item.child.length > 0)) return

                if (contentIsHref) {
                    const isYoutube = this.matchYoutubeUrl(item.content);

                    if (isYoutube) {
                        this.openModal('youtube', content)
                        return;
                    }

                    const isAudio = this.linkIsAudio(item.content)

                    if (isAudio) {
                        this.openModal('audio', content)
                        return;
                    }
                    window.open(content, '_blank')
                } else {
                    this.openModal('text', content)
                }
                this.menu = false
                this.$refs.myTreeview.updateAll(false);
            },
            checkLoginPage(menuitem) {
                if (this.$route.name === 'login') {
                    return menuitem.loginPage
                } else {
                    return true
                }
            },
            linkAction(actName) {
                switch (actName) {
                    case 'toHome':
                        this.menu = false
                        this.$router.push('/')
                        break
                    case 'toShiftPage':
                        this.menu = false
                        this.$router.push('/shift')
                        break
                    case 'toNewOrder':
                        this.menu = false
                        this.$router.push('/order/new')
                        break
                    case 'toServices':
                        this.menu = false
                        this.$router.push('/order/chooseservices')
                        break
                    case 'toCollector':
                        this.menu = false
                        window.open('https://collector.cash.2atm.ru', '_blank').focus();
                }
            },
            toHome() {
                this.menu = false
                this.$router.push('/')
            },
            logOut() {
                // document.getElementById('logout-form').submit();
                this.disLogOut = true
                this.$store.dispatch('login/logout').then(() => {
                    this.menu = false
                    this.$router.push('/login', {force: true})
                })
            },
            openMenu() {
                this.width = 100
                this.$store.commit('updateDisplayNone', true);
            },
            closeMenu() {
                this.width = 0
                this.$store.commit('updateDisplayNone', false);
            },
            //move to Vuex
            openShift() {
                this.$store.dispatch('shift/openShift')
            },
            closeShift() {
                this.$store.dispatch('shift/closeShift', this.shiftData)
                this.$store.dispatch('shift/fetchShiftData')
            },
            reloadKKMStatus() {
                this.$store.dispatch('fetchKKMStatus')
            },
            openKKMShift() {
                this.$store.dispatch('openKKMShift')
            },
            closeKKMShift() {
                this.$store.dispatch('closeKKMShift')
            },

        }
    };
</script>

<style>
.burger-tree-button {
  width: 100%;
  height: 100%;
}
</style>
